import {useEffect} from 'react';

import appConfig from '../../../config/appConfig';
import connectivityService from '../../../services/device/connectivityService';
import appRouterService from '../../../services/route/appRouterService';
import userBrowserService from '../../../services/user/userBrowserService';
import userDeviceService from '../../../services/user/userDeviceService';
import loadableRoutes from '../../Routes/loadableRoutes';

const BrowserVerificationPage = () => {
    useEffect(() => {
        const verifyBrowser = async () => {
            const isConnectivitySupported = connectivityService.isBleOrUsbSupported();
            const isMobileIOSDevice = userDeviceService.isMobileIOSDevice();
            const isTabletIOSDevice = userDeviceService.isTabletIOSDevice();
            const isAppleTouchDevice = isMobileIOSDevice || isTabletIOSDevice;
            const shouldRedirectToNotCompatiblePage =
                !isConnectivitySupported || (isAppleTouchDevice && !userBrowserService.isBrowserTrusted());
            const isUsbSupported = connectivityService.isUsbSupported();
            const isBLEEnabled = appConfig.getIsBLEEnabled();

            await userDeviceService.checkBluetoothAvailability();

            const forwardToNotCompatibleBrowserPage = async () => {
                await loadableRoutes.NotCompatibleBrowserPage.load();
                appRouterService.forwardToNotCompatibleBrowserPage();
            };

            if (shouldRedirectToNotCompatiblePage) {
                await forwardToNotCompatibleBrowserPage();
            } else {
                if (isUsbSupported || isBLEEnabled) {
                    appRouterService.forwardToLegalDisclaimerPage();
                } else {
                    await forwardToNotCompatibleBrowserPage();
                }
            }
        };

        verifyBrowser();
    }, []);

    return null;
};

export default BrowserVerificationPage;
